export default "__VITE_ASSET__8446d140__"